import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "";

if (!apiUrl) {
  console.warn("REACT_APP_API_URL is not defined in environment variables");
}

axios.defaults.withCredentials = true;
axios.defaults.baseURL = apiUrl;

// Add request interceptor for debugging
axios.interceptors.request.use(
  (config) => {
    console.log("API Request:", config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === "Network Error") {
      console.error("Network Error: Check if API server is running and REACT_APP_API_URL is correct");
      console.error("Current API URL:", apiUrl || "Not set");
    }
    return Promise.reject(error);
  }
);

export default axios;
